import React from 'react';
import { Activity } from '../../types';
import { Avatar } from '../ui/Avatar';
import { formatRelativeTime } from '../../utils/format';
import { ShoppingBag, UserPlus, Megaphone, Calendar } from 'lucide-react';
interface ActivityFeedProps {
  activities: Activity[];
}
export function ActivityFeed({
  activities
}: ActivityFeedProps) {
  const getIcon = (type: Activity['type']) => {
    switch (type) {
      case 'sale':
        return <ShoppingBag className="h-4 w-4 text-emerald-400" data-id="element-17" />;
      case 'lead':
        return <UserPlus className="h-4 w-4 text-blue-400" data-id="element-18" />;
      case 'campaign':
        return <Megaphone className="h-4 w-4 text-secondary-light" data-id="element-19" />;
      case 'contact':
        return <Calendar className="h-4 w-4 text-accent" data-id="element-20" />;
    }
  };
  const getBgColor = (type: Activity['type']) => {
    switch (type) {
      case 'sale':
        return 'bg-emerald-500/10';
      case 'lead':
        return 'bg-blue-500/10';
      case 'campaign':
        return 'bg-secondary/10';
      case 'contact':
        return 'bg-accent/10';
    }
  };
  return <div className="space-y-6" data-id="element-21">
      <div className="flex items-center justify-between" data-id="element-22">
        <h3 className="text-lg font-bold text-white" data-id="element-23">Atividades Recentes</h3>
        <button className="text-xs text-primary hover:text-primary-light font-medium" data-id="element-24">
          Ver tudo
        </button>
      </div>

      <div className="relative space-y-0" data-id="element-25">
        {activities.map((activity, index) => <div key={activity.id} className="flex gap-4 pb-6 relative group" data-id="element-26">
            {/* Connector Line */}
            {index !== activities.length - 1 && <div className="absolute left-[19px] top-10 bottom-0 w-0.5 bg-slate-800 group-hover:bg-slate-700 transition-colors" data-id="element-27" />}

            {/* Icon */}
            <div className={`relative z-10 flex-shrink-0 h-10 w-10 rounded-full flex items-center justify-center ${getBgColor(activity.type)} ring-4 ring-background`} data-id="element-28">
              {getIcon(activity.type)}
            </div>

            {/* Content */}
            <div className="flex-1 pt-1" data-id="element-29">
              <p className="text-sm text-text-primary" data-id="element-30">
                <span className="font-medium text-white" data-id="element-31">
                  {activity.user.name}
                </span>{' '}
                {activity.description}
              </p>
              <p className="text-xs text-text-muted mt-1" data-id="element-32">
                {formatRelativeTime(activity.timestamp)}
              </p>
            </div>
          </div>)}
      </div>
    </div>;
}